import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  CardContent,
  Button,
  Typography,
  TextField,
  Select,
  MenuItem,
  Paper
} from "@material-ui/core";
import MapContainer from "../MapContainer";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import { selectReport } from "./selectors";
import { getReport,setReport,getJobPackReports } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";

import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";
import styled from "styled-components";
import "../reports.css";
import PrintIcon from "@material-ui/icons/Print";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
const ActionButton = styled(Button)`
  @media print {
    visibility: hidden;
  }
`;
let checkedit = "";
class ThreeMinuteTrafficCount extends Component {
  constructor(props) {
    super(props);
    let path = props.location.pathname.split("/");
    checkedit = path[1];
    this.state = {
      imageModal: false,
      selectedImg: false,
      report: false,
      editing:
        path[1] === "report-view"
          ? false
          : path[1] === "report-view-standalone"
          ? false
          : true,
      title: document.title,
      reportType: path[4].replace(/-/g, "_"),
    };

    if (path[2] === "reports") {
      props.getReport(
        path[2].replace(/-/g, "_"),
        path[3],
        path[4].replace(/-/g, "_"),
        path[5].replace(/_/g, " ").replace(/\./g, ":")
      );
    } else {
      props.getJobPackReports(
        props.match.params.uid,
        path[2].replace(/-/g, "_"),
        path[3],
        path[4].replace(/-/g, "_"),
        path[5].replace(/-/g, "_"),
        path[7].replace(/-/g, "_"),
        props.match.params.report_id.replace(/_/g, " ").replace(/\./g, ":")
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.report !== prevProps.report) {
      this.setState({ report: this.props.report });
    }
  }
  renderInspection = (key, value = false) => {
    let col = "green";
    value === "Amber"
      ? (col = "green")
      : value === "U"
      ? (col = "orange")
      : value === "I"
      ? (col = "red")
      : (col = "grey");
    if (this.state.editing) {
      return (
        <Select
          value={
            this.state.report[key] === undefined
              ? false
              : this.state.report[key]
          }
          onChange={(event) => {
            let report = {
              ...this.state.report,
              [key]: event.target.value,
            };
            this.setState({ report });
          }}
          style={{ minWidth: "100%", background: col }}
        >
          <MenuItem value={"A"} style={{ background: "green" }}>
            A
          </MenuItem>
          <MenuItem value={"U"} style={{ background: "orange" }}>
            U
          </MenuItem>
          <MenuItem value={"I"} style={{ background: "red" }}>
            I
          </MenuItem>
          <MenuItem value={"N/R"} style={{ background: "grey" }}>
            N/R
          </MenuItem>
        </Select>
      );
    } else {
      return <div style={this.statusStyle(value)}>{value}</div>;
    }
  };
  renderText = (key, value) => {
    if (this.state.editing) {
      return (
        <TextField
          value={this.state.report[key]}
          onChange={event => {
            let report = {
              ...this.state.report,
              [key]: event.target.value
            };
            this.setState({ report });
          }}
        />
      );
    } else {
      return value;
    }
  };
  renderText1 = key => {
    if (this.state.editing) {
      return (
        <TextField
          value={key}
          // onChange={event => {
          //     let report = {
          //         ...this.state.report,
          //         [key]: event.target.value
          //     };
          //     this.setState({ report });
          // }}
        />
      );
    } else {
      return key;
    }
  };
  renderDropDown = (key, value, opts) => {
    if (this.state.editing) {
      return (
        <Select
          style={{ width: "100%" }}
          value={this.state.report[key] === "" ? "N/A" : this.state.report[key]}
          onChange={event => {
            let report = {
              ...this.state.report,
              [key]: event.target.value
            };
            this.setState({ report });
          }}
        >
          <MenuItem value="N/A">N/A</MenuItem>
          {opts.map(option => {
            return (
              <MenuItem value={option} key={option}>
                {option}
              </MenuItem>
            );
          })}
        </Select>
      );
    } else {
      return value === "" ? "N/A " : value;
    }
  };
  statusStyle = (value) => {
    let color = "black";
    let background = "white";

    if (value === "Amber") {
      background = "orange";
    } else if (value === "Green") {
      background = "green";
    } else if (value === "Red") {
      background = "red";
    } else {
      background = "grey";
    }

    return { minWidth: "100%", minHeight: "100%", color, background,textAlign:"center" };
  };
 

  renderSignature(attachedSignature) {
    let photoRow = 2;
    let photoCell = 1;
    
      let photoInfo = (
        <React.Fragment key={attachedSignature.timestamp}>
          <div
            style={cellStyle(photoRow, photoCell, photoRow, photoCell, true)}
          >
            {attachedSignature.signature_name}
          </div>
          <div
            style={cellStyle(
              photoRow,
              photoCell + 1,
              photoRow,
              photoCell + 1,
              true
            )}
          >
            {attachedSignature.signature_timestamp}
          </div>
          <div
            style={cellStyle(
              photoRow + 1,
              photoCell,
              photoRow + 1,
              photoCell + 2
            )}
          >
            <img
              src={attachedSignature.signature_url}
              alt="Site "
              onClick={() => {
                this.setState({
                  selectedImg: attachedSignature.signature_url,
                  imageModal: true
                });
              }}
              style={{
                width: 100,
                height: 100,
                margin: "auto",
                cursor: "pointer"
              }}
            />
          </div>
        </React.Fragment>
      );
      photoCell += 2;
      if (photoCell === 9) {
        photoRow += 2;
        photoCell = 1;
      }
      return photoInfo;
    
  }

  renderPhotos(attachedPhotos) {
    let photoRow = 2;
    let photoCell = 1;
    return attachedPhotos.map((photo, i) => {
      let photoInfo = (
        <React.Fragment key={i}>
          <div
            style={cellStyle(photoRow, photoCell, photoRow, photoCell, true)}
          >
            {photo.photo_name}
          </div>
          <div
            style={cellStyle(
              photoRow,
              photoCell + 1,
              photoRow,
              photoCell + 1,
              true
            )}
          >
            {photo.photo_timestamp}
          </div>
          <div
            style={cellStyle(
              photoRow + 1,
              photoCell,
              photoRow + 1,
              photoCell + 2
            )}
          >
            <img
              src={photo.photo_url}
              alt="Site "
              onClick={() => {
                this.setState({
                  selectedPhoto: photo,
                  imageModal: true
                });
              }}
              style={{
                width: 300,
                height: 300,
                margin: "auto",
                cursor: "pointer"
              }}
            />
          </div>
        </React.Fragment>
      );
      photoCell += 2;
      if (photoCell === 9) {
        photoRow += 2;
        photoCell = 1;
      }
      return photoInfo;
    });
  }
  render() {
    //let report = this.props.report === false ? false : this.props.report;
    //  let dp = this.renderDropDown;

    let gstyle = gridStyle;
    let cstyle = cellStyle;
    let RCount = 2;
    let color = "#0188cc";
    const {  report, selectedImg } = this.state;
    return (
      <Card>
        <StyledHeader style={{ background: "#0188cc" }}>
          <Typography variant="headline" style={{ color: "white", fontSize:"20px" }}><b>Three Minute Traffic Count Report</b></Typography>
          <ReactToPrint
            onBeforePrint={() => {
              setTimeout(undefined, 2000);
              document.title =
                "Examination Report- " +
                this.props.match.params.report_id
                  .replace(/_/g, " ")
                  .replace(/\./g, ":");
            }}
            onAfterPrint={() => {
              document.title = this.state.title;
            }}
            trigger={() => (
              <PrintIcon
                style={{
                  fontSize: "36px",
                  marginRight: "30px",
                  float: "right",
                  color: "white"
                }}
                color="primary"
                variant="contained"
                
              />
              // <Button
              //   style={{
              //     fontSize: "30px",
              //     marginBottom: "10px"
              //   }}
              //   color="primary"
              //   variant="raised"
              // >
              //   Print
              // </Button>
            )}
            content={() => this.componentRef}
          />
        </StyledHeader>
        <CardContent>
          
          {report && (
            <>
              <div ref={el => (this.componentRef = el)}>
                {this.props.header && <this.props.header />}
                <div
                  className="imgDiv"
                  style={{
                    float: "left",
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between"
                  }}
                >
                  <Typography variant="headline">
                  Three Minute Traffic Count Report
                  </Typography>
                </div>
                <div style={{ width: "100%" }}>
                  <div style={{ width: "45%", float: "left" }}>
                    <div style={gstyle(5, 13)}>
                      <div style={cstyle(1, 1, 1, 13, false, true)}>
                        <b>Report Details</b>
                      </div>
                      <div style={cstyle(2, 1, 2, 13)}>
                        <b>Name: </b>&nbsp; {report.user_name ? report.user_name : "N/A"}
                      </div>
                 
                      <div style={cstyle(3, 1, 3, 13)}>
                        <b>Email:</b>&nbsp; {report.user_email ? report.user_email : "N/A"}
                      </div>
                  
                      <div style={cstyle(4, 1, 4, 13)}>
                        <b>Date: </b>&nbsp;  {report.timestamp ? report.timestamp : "N/A"}
                      </div>
               
                      <div style={cstyle(5, 1, 5, 13)}>
                        <b>Type Of Work: </b>&nbsp; {report.type_of_work}
                      </div>
                    
                      <div style={cstyle(6, 1, 6, 13)}>
                        <b>Client: </b>&nbsp; {report.client}
                      </div>
                 
                      <div style={cstyle(7, 1, 7, 13)}>
                        <b>TTOS: </b>&nbsp;  {report.ttos}
                      </div>
                   
                      <div style={cstyle(8, 1, 8, 13)}>
                        <b>Job Name: </b>&nbsp; {report.job_name}
                      </div>
                    
                      <div style={cstyle(9, 1, 9, 13)}>
                        <b>Comments: </b>&nbsp; {report.comments}
                      </div>
                 
                      {/* <div style={cstyle(10, 1, 10, 13)}>
                        <b>Comments: </b>
                      </div>
                      <div style={cstyle(10, 7, 10, 13, true)}>
                        {report.location}
                      </div> */}
                    </div>
                  </div>
                  
                  <Paper
                    style={{
                      float: "left",
                      marginLeft: "2%",
                      width: "50%",
                      zIndex: "500"
                      
                    }}
                  >
                    <Typography style={{ padding: "10px" }} variant="title">
                        <b>Report Location:</b>
                    </Typography>
                    <MapContainer
                      lat={+report.location_lat}
                      long={+report.location_lon}
                    />
                  </Paper>
                  
                </div>
                <div style={{ width: "100%",clear: "both" }}>
                  
                    <div style={gstyle(5, 13)}>
                      <div style={cstyle(1, 1, 1, 13, false)}>
                      <b>Job Address : </b> {report.location} 
                      </div>
                    </div>
                  
                </div>
                <div style={{
                      width: "100%",
                      clear: "both",
                    }}>
                       
                  {
                    report.type_of_work === "Direct Lane 1 Closure" 
                      ? 
                      <img
                      alt={"tagicon"}
                      src={require("./images/direct_lane_1_closure.png")}
                      width="800"
                      height="800"
                      display= "block"
                      margin-left= "auto"
                      margin-right= "auto"
                      />
                      : <></>
                  }

                  {
                    report.type_of_work === "Mobile Operations" 
                      ? 
                      <img
                      alt={"tagicon"}
                      src={require("./images/mobile_lane_closure.png")}
                      width="800"
                      height="800"
                      display= "block"
                      margin-left= "auto"
                      margin-right= "auto"
                      />
                      : <></>
                  }

                  {
                    report.type_of_work === "Semi-Static" 
                      ? 
                      <img
                      alt={"tagicon"}
                      src={require("./images/semi_static_table.png")}
                      width="500"
                      height="500"
                      display= "block"
                      margin-left= "auto"
                      margin-right= "auto"
                      />
                      : <></>
                  }

                  {
                    report.type_of_work === "Static Operations" 
                      ? 
                      <img
                      alt={"tagicon"}
                      src={require("./images/static_operations.png")}
                      width="800"
                      height="800"
                      display= "block"
                      margin-left= "auto"
                      margin-right= "auto"
                      />
                      : <></>
                  }

                  
               
                </div>

                <div
                    style={{
                      width: "100%",
                      clear: "both"
                    }}
                  >

                                <div style={gstyle(5, 8, null, color)}>
                                    <div
                                        style={cstyle(1, 1, 1, 2, false, true)}
                                    >
                                        <b>Traffic Count </b>
                                    </div>
                                    <div style={cstyle(2, 1, 2, 2)}>
                                        <b>Serial No  </b>
                                    </div>
                                    <div style={cstyle(2, 2, 3, 3)}>
                                        <b>Total Vehicle Count:</b>
                                    </div>
                                    <div style={cstyle(2, 3, 2, 4)}>
                                        <b>Total Car Count:</b>
                                    </div>

                                    <div style={cstyle(2, 4, 2, 5)}>
                                        <b>Total HGV Count:</b>
                                    </div>
                                    <div style={cstyle(2, 5, 2, 6)}>
                                        <b>Finish Timestamp:</b>
                                    </div>
                                    <div style={cstyle(2, 6, 2, 7)}>
                                        <b>OK for TTM:</b>
                                    </div>
                                    <div style={cstyle(2, 7, 2, 8)}>
                                        <b>Map Location:</b>
                                    </div>
                                    {report.traffic_counts &&
                                       report.traffic_counts.map((f, i) => {
                                         RCount++;
                                            return (
                                                <React.Fragment key={RCount}>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            1,
                                                            RCount,
                                                            2
                                                        )}
                                                    >
                                                        {i+1}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            2,
                                                            RCount,
                                                            3
                                                        )}
                                                    >
                                                        {f.total_vehicle_count}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            3,
                                                            RCount,
                                                            4,
                                                            true
                                                        )}
                                                    >
                                                         {f.total_car_count}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            4,
                                                            RCount,
                                                            5
                                                        )}
                                                    >
                                                        {f.total_hgv_count}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            5,
                                                            RCount,
                                                            6
                                                        )}
                                                    >
                                                         {f.finish_timestamp}
                                                    </div>
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            6,
                                                            RCount,
                                                            7
                                                        )}
                                                    >
                                                        {f.ok_for_ttm}
                                                    </div>
                                                   
                                                    <div
                                                        style={cellStyle(
                                                            RCount,
                                                            7,
                                                            RCount,
                                                            8
                                                        )}
                                                    >
                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                pageBreakInside:
                                                                    "avoid",
                                                                height: "auto",
                                                            }}
                                                        >
                                                            {f.location_lat &&
                                                                f.location_lon && (
                                                                    <img
                                                                        style={{
                                                                            width:
                                                                                "130px",
                                                                            marginTop:
                                                                                "12px",
                                                                        }}
                                                                        alt="static map"
                                                                        src={`https://maps.googleapis.com/maps/api/staticmap?center=${f.location_lat},${f.location_lon}&zoom=16&size=300x150&maptype=roadmap&markers=color:red%7C${f.location_lat},${f.location_lon}&key=AIzaSyD489nheoQV_OPuhsC9yDkuqe7wmiW-1R8`}
                                                                    />
                                                                )}
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            );
                                        })}
                                </div>
                  </div>
                
            
                <div style={gstyle(5, 10)}>
                  <div style={cstyle(1, 1, 1, 1, false, true)}>
                    <b>Attached Signatures</b>
                  </div>
                  {report.attached_signature &&
                    this.renderSignature(report.attached_signature)}
                </div>
              </div>
            </>
          )}
        <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    {this.state.editing && checkedit === "report-edit-jobpack" && (

                                        <Link
                                            to={this.props.location.pathname.replace(
                                                "report-edit-jobpack",
                                                "report-view"
                                            )}
                                        >
                                            <div>
                                                <ActionButton
                                                    style={{ marginRight: 10 }}
                                                    onClick={() => {

                                                        this.props.setReport(
                                                            this.state.report,
                                                            this.props.location
                                                                .pathname
                                                        );
                                                    }}
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Submit
                                            </ActionButton>
                                                <ActionButton
                                                    color="secondary"
                                                    variant="contained"
                                                >
                                                    Cancel
                                            </ActionButton>
                                            </div>
                                        </Link>
                                    )}

                                    {!this.state.editing && checkedit === "report-view" && (
                                        <Link
                                            to={this.props.location.pathname.replace(
                                                "report-view",
                                                "report-edit-jobpack"
                                            )}
                                        >
                                            {/* <ActionButton
                                                variant="contained"
                                                color="primary"
                                            >
                                                Edit
                                        </ActionButton> */}
                                        </Link>
                                    )}
                                </div>



                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between"
                                    }}
                                >
                                    {this.state.editing && checkedit === "report-edit" && (

                                        <Link
                                            to={this.props.location.pathname.replace(
                                                "report-edit",
                                                "report-view-standalone"
                                            )}
                                        >
                                            <div>
                                                <ActionButton
                                                    style={{ marginRight: 10 }}
                                                    onClick={() => {

                                                        this.props.setReport(
                                                            this.state.report,
                                                            this.props.location
                                                                .pathname
                                                        );
                                                    }}
                                                    variant="contained"
                                                    color="primary"
                                                >
                                                    Submit
                                            </ActionButton>
                                                <ActionButton
                                                    color="secondary"
                                                    variant="contained"
                                                >
                                                    Cancel
                                            </ActionButton>
                                            </div>
                                        </Link>
                                    )}

                                    {!this.state.editing && checkedit === "report-view-standalone" && (
                                        <Link
                                            to={this.props.location.pathname.replace(
                                                "report-view-standalone",
                                                "report-edit"
                                            )}
                                        >
                                            {/* <ActionButton
                                                variant="contained"
                                                color="primary"
                                            >
                                                Edit
                                        </ActionButton> */}
                                        </Link>
                                    )}
                                </div>

          {report && (
            <Modal isOpen={this.state.imageModal}>
              <ModalHeader>Additional Notes Image</ModalHeader>
              <ModalBody style={{ margin: "auto" }}>
                <img
                  src={
                    selectedImg === undefined ||
                    selectedImg === null ||
                    selectedImg === ""
                      ? noImg
                      : selectedImg
                  }
                  alt="Site"
                  style={{ width: "350px", height: "350px" }}
                />
              </ModalBody>
              <ModalFooter>
                <Button
                  variant="outlined"
                  onClick={() => {
                    this.setState({
                      selectedImg: false,
                      imageModal: false
                    });
                  }}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </CardContent>
      </Card>
    );
  }
}
export default connect(
  store => {
    return { report: selectReport(store) };
  },
  { getReport,setReport,getJobPackReports }
)(ThreeMinuteTrafficCount);
